/**
 * Mock data for company dashboard in the SCAD system
 * Centralized data source to be used across all components
 */

export const recentApplicationsData = [
  {
    id: 1,
    studentName: "John Smith",
    jobTitle: "Frontend Developer Intern",
    university: "Stanford University",
    appliedDate: "2025-05-06",
    status: "pending"
  },
  {
    id: 2,
    studentName: "Emily Johnson",
    jobTitle: "UI/UX Design Intern",
    university: "MIT",
    appliedDate: "2025-05-05",
    status: "reviewing"
  },
  {
    id: 3,
    studentName: "Michael Brown",
    jobTitle: "Backend Developer Intern",
    university: "Harvard University",
    appliedDate: "2025-05-04",
    status: "interview"
  }
];

export const currentInternsData = [
  {
    id: 101,
    studentName: "Sarah Wilson",
    jobTitle: "Frontend Developer Intern",
    university: "UC Berkeley",
    startDate: "2025-03-15",
    endDate: "2025-06-15",
    supervisor: "Alex Thompson",
    status: "current intern"
  },
  {
    id: 102,
    studentName: "David Lee",
    jobTitle: "Data Science Intern",
    university: "Columbia University",
    startDate: "2025-02-01",
    endDate: "2025-07-31",
    supervisor: "Jennifer Garcia",
    status: "current intern"
  },
  {
    id: 103,
    studentName: "Jessica Martinez",
    jobTitle: "Marketing Intern",
    university: "UCLA",
    startDate: "2025-01-10",
    endDate: "2025-05-10",
    supervisor: "Robert Chen",
    status: "internship complete",
    evaluation: {
      technical: 85,
      communication: 92,
      problemSolving: 78,
      teamwork: 90,
      overall: 86,
      strengths: "Jessica demonstrated excellent communication skills and creativity in her marketing campaigns. She was a team player who consistently contributed valuable ideas during brainstorming sessions.",
      improvements: "Could benefit from developing more technical skills related to digital marketing analytics and data interpretation tools.",
      comments: "Jessica has a bright future in marketing. She showed remarkable growth during her internship period and quickly adapted to our company culture."
    }
  },
  {
    id: 104,
    studentName: "Miguel Hernandez",
    jobTitle: "Backend Developer Intern",
    university: "Georgia Tech",
    startDate: "2025-01-15",
    endDate: "2025-05-15",
    supervisor: "Lisa Wang",
    status: "internship complete"
  }
]; 